import { routes as app } from '../app';

export const routes = [
  ...app
]
